import { ReasonTypes } from './types';
export const REASONS = [
  ReasonTypes.RefusalInInforming,
  ReasonTypes.NotIdentified,
];

export const REASONS_MAP_TEXT: Record<ReasonTypes, string> = {
  [ReasonTypes.RefusalInInforming]: 'Отказ пациента от информирования',
  [ReasonTypes.NotIdentified]: 'Не идентифицирован',
};
